import React from 'react';
import PropTypes from 'prop-types';

import DialogWithConfirmationLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithConfirmationLayout';

export default function AlertDeleteConfirmationDialog(props) {
  const { alertId, removeAlert, selfClose } = props;

  return (
    <DialogWithConfirmationLayout
      {...props}
      size="md"
      character="!"
      layoutType="info"
      header="Delete"
      onYesClick={() => {
        removeAlert(alertId);
        selfClose();
      }}>
      Are you sure you want to delete this alert?
    </DialogWithConfirmationLayout>
  );
}

AlertDeleteConfirmationDialog.propTypes = {
  alertId: PropTypes.string.isRequired,
  selfClose: PropTypes.func.isRequired,
  removeAlert: PropTypes.func.isRequired,
};
